"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.DatagridFilter = ({ children, label, noResetButton, onClickResetButton }) => (React.createElement("div", { className: "filter" },
    React.createElement("div", { className: "filter-header" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-8" },
                React.createElement("h3", { className: "filter-title" }, label)),
            !noResetButton && (React.createElement("div", { className: "col-4 text-right" },
                React.createElement("a", { className: "text-uppercase", href: "#", onClick: onClickResetButton },
                    React.createElement("small", null, "Reset")))))),
    React.createElement("div", { className: "filter-body" }, children)));
exports.DatagridFilter.displayName = 'DatagridFilter';
exports.DatagridFilter.defaultProps = {
    noResetButton: false,
    onClickResetButton: () => { return; },
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Datagrid/DatagridFilter.tsx
// module id = 253
// module chunks = 0